import classNames from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import './BookableItem.css';

// Props
// title: string;
// description: string;
// disabledDescription: string;
// helpText: string;
// quantity: number;
// numRemaining: number;
// // show as toggle instead of quantity input
// singleton: boolean;
// selected?: boolean;
// disabled: boolean;
// minusDisabled: boolean;
// plusDisabled: boolean;
// handleClickPlus?: () => void;
// handleClickMinus?: () => void;
// handleClickItem?: () => void;
// handleChangeQuantity?: (newQuantity: number) => void;
// landscape: boolean;
// // show station participant
// isStation?: boolean;
// canTimeSplit?: boolean;
// subQuantity?: number;
// handleClickSubPlus?: () => void;
// handleClickSubMinus?: () => void;
// handleChangeSubQuantity?: (newQuantity: number) => void;
// subMinusDisabled?: boolean;
// subPlusDisabled?: boolean;

const mapStateToProps = (state) => {
  return {
    languageObj: state.language.sub_components.bookable_item_js,
  };
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(class BookableItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      helpShown: false,
      helpShownExtra: false
    };
  }

  onClickPlus = () => {
    if (this.props.plusDisabled === false) {
      this.props.handleClickPlus && this.props.handleClickPlus();
    }
  }

  onClickMinus = () => {
    if (this.props.minusDisabled === false) {
      this.props.handleClickMinus && this.props.handleClickMinus();
    }
  }

  onChangeQuantity = e => {
    const value = e.currentTarget.value;
    const valueNum = value ? parseInt(value, 10) : 0;
    if (isNaN(valueNum) === false && this.props.handleChangeQuantity) {
      this.props.handleChangeQuantity(valueNum);
    }
  }

  onClickQuantity = e => {
    e.currentTarget.select();
  }

  onClickItem = () => {
    if (this.props.disabled === false) {
      this.props.handleClickItem && this.props.handleClickItem();
    }
  }

  onClickHelp = () => {
    this.setState({
      helpShown: !this.state.helpShown
    });
  }

  onClickHelpExtra = () => {
    this.setState({
      helpShownExtra: !this.state.helpShownExtra
    });
  }

  onClickSubPlus = () => {
    if (this.props.subPlusDisabled === false && this.props.canTimeSplit) {
      this.props.handleClickSubPlus && this.props.handleClickSubPlus();
    }
  }

  onClickSubMinus = () => {
    if (this.props.subMinusDisabled === false && this.props.canTimeSplit) {
      this.props.handleClickSubMinus && this.props.handleClickSubMinus();
    }
  }

  onChangeSubQuantity = e => {
    const value = e.currentTarget.value;
    const valueNum = value ? parseInt(value, 10) : 0;
    if (isNaN(valueNum) === false && this.props.handleChangeSubQuantity && this.props.canTimeSplit) {
      this.props.handleChangeSubQuantity(valueNum);
    }
  }

  render() {
    const itemClasses = classNames('BookableItem', {
      'BookableItem--disabled': this.props.disabled,
      'BookableItem--selected': this.props.selected,
      'BookableItem--singleton': this.props.singleton,
      'BookableItem-TimeSplit': this.props.canTimeSplit
    });
    const sliderClasses = classNames('BookableItem-sliderContainer', {
      'BookableItem-sliderContainer--help': this.state.helpShown
    });
    const sliderExtraClasses = classNames('BookableItem-sliderContainer', {
      'BookableItem-sliderContainer--help': this.state.helpShownExtra
    });
    const minusClasses = classNames('BookableItem-minus', {
      'BookableItem-minus--disabled': this.props.minusDisabled,
    });
    const plusClasses = classNames('BookableItem-plus', {
      'BookableItem-plus--disabled': this.props.plusDisabled,
    });
    const subMinusClasses = classNames('BookableItem-minus', {
      'BookableItem-minus--disabled': this.props.subMinusDisabled,
    });
    const subPlusClasses = classNames('BookableItem-plus', {
      'BookableItem-plus--disabled': this.props.subPlusDisabled,
    });
    return (
      <div className={itemClasses}>
        <div className={'BookableItem-contentContainer'}>
          <div className={'BookableItem-content'} onClick={this.onClickItem}>
            <div className={'BookableItem-contentSpacer'}>{}</div>
            {this.props.title && (
              <div className={'BookableItem-title'}>
                {this.props.title}
              </div>
            )}
            <div className={'BookableItem-contentSpacer'}>{}</div>
            {this.props.singleton === false && (
              <div className={'BookableItem-quantityRow'}>
                <img
                  alt={'Minus'}
                  className={minusClasses}
                  src={`${process.env.PUBLIC_URL}/images/icons/SubtractIcon.png`}
                  onClick={this.onClickMinus}
                />
                <input
                  className={'BookableItem-quantity'}
                  value={this.props.quantity}
                  onChange={this.onChangeQuantity}
                  onClick={this.onClickQuantity}
                />
                <img alt={'Plus'} className={plusClasses} src={`${process.env.PUBLIC_URL}/images/icons/AddIcon.png`} onClick={this.onClickPlus} />
              </div>
            )}
            <div className={'BookableItem-contentSpacer'}>{}</div>
            {this.props.description && (
              <div className={'BookableItem-description'}>
                {this.props.disabled ? (this.props.numRemaining ? this.props.disabledDescription : '') : this.props.description}
              </div>
            )}
            <div className={'BookableItem-contentSpacer'}>{}</div>
            <div className={'BookableItem-remaining'}>
              {this.props.singleton && (
                this.props.disabled
                  ? (this.props.numRemaining ? this.props.languageObj.props_disabled.num_remaining.true : this.props.languageObj.props_disabled.num_remaining.false)
                  : this.props.selected ? this.props.languageObj.props_enabled.props_selected.true : this.props.languageObj.props_enabled.props_selected.false
              )}
              {this.props.singleton === false && (
                '' + this.props.numRemaining + ' ' + (this.props.landscape ? this.props.languageObj.props_landscape.true : this.props.languageObj.props_landscape.false)
              )}
            </div>
          </div>
          <div className={sliderClasses}>
            <div className={'BookableItem-slider'}>
              <div className={'BookableItem-sliderIcon'} onClick={this.onClickHelp}>
                <div className={'BookableItem-help'}>
                  <div className={'BookableItem-help-pulse'}>
                    {this.state.helpShown
                      ? <img alt={'Help Arrow'} className={'BookableItem-helpArrow'} src={`${process.env.PUBLIC_URL}/images/icons/ArrowRight.png`} />
                      : '?'
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className={'BookableItem-helpText'}>
              <div className={'BookableItem-helpText-inner'}>
                {this.props.helpText}
              </div>
            </div>
          </div>
        </div>
        {this.props.isStation && !this.props.singleton && this.props.canTimeSplit && (
          <div className={'BookableItem-contentContainer'}>
            <div className={'BookableItem-extra'}>
              <div className={'BookableItem-contentSpacer-extra'}>{}</div>
              {this.props.canTimeSplit && (
                <div className={'BookableItem-quantityRow-extra'}>

                  <img
                    alt={'Sub Minus'}
                    className={subMinusClasses}
                    src={`${process.env.PUBLIC_URL}/images/icons/SubtractIcon.png`}
                    onClick={this.onClickSubMinus}
                  />
                  <input
                    className={'BookableItem-quantity'}
                    value={this.props.subQuantity || 0}
                    onChange={this.onChangeSubQuantity}
                    onClick={this.onClickQuantity}
                  />
                  <img alt={'Sub Plus'} className={subPlusClasses} src={`${process.env.PUBLIC_URL}/images/icons/AddIcon.png`} onClick={this.onClickSubPlus} />

                </div>
              )}
              <div className={'BookableItem-contentSpacer-extra'}>{}</div>
              <div className={'BookableItem-description-extra'}>
                {this.props.canTimeSplit ?
                  (!this.props.subQuantity || (this.props.subQuantity && this.props.subQuantity - this.props.quantity <= 0)) ?
                    this.props.languageObj.time_split.sub_quantity :
                    (this.props.subQuantity - this.props.quantity) * 2 + this.props.languageObj.time_split.turns +
                    (this.props.subQuantity - this.props.quantity) + this.props.languageObj.time_split.headset + ((this.props.subQuantity - this.props.quantity) === 1 ? this.props.languageObj.time_split.not_plural : this.props.languageObj.time_split.plural) + this.props.languageObj.time_split.throughout :
                  this.props.languageObj.time_split.suitable}
              </div>
              <div className={'BookableItem-contentSpacer-extra'}>{}</div>
            </div>
            <div className={sliderExtraClasses}>
              <div className={'BookableItem-slider'}>
                <div className={'BookableItem-sliderIcon-extra'} onClick={this.onClickHelpExtra}>
                  <div className={'BookableItem-help'}>
                    <div className={'BookableItem-help-pulse'}>
                      {this.state.helpShownExtra
                        ? <img alt={'Help Arrow'} className={'BookableItem-helpArrow'} src={`${process.env.PUBLIC_URL}/images/icons/ArrowRight.png`} />
                        : '?'
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div className={'BookableItem-helpText-extra'}>
                <div className={'BookableItem-helpText-inner'}>
                  {this.props.languageObj.time_split.share}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
})
